export const copy = (text: string) => {
  const dom = document.createElement('span')
  document.body.appendChild(dom)
  dom.innerText = text
  const selection = window.getSelection()
  const range = document.createRange()
  selection.removeAllRanges()
  range.selectNode(dom)
  selection.addRange(range)
  document.execCommand('copy')
  selection.removeAllRanges()
  document.body.removeChild(dom)
}
